import 'what-input';
import './polyfill';
import {
  articles,
  categoryArticles,
  featuresArticles,
  focusArticles,
  monthlyArticles,
  monthlyDates,
  searchArticles,
  tagArticles,
} from './articles';
import { hamburgerMenu, scrollToCenterNav } from './header';
import {
  entryBoxSlider,
  monthlySlider,
  mvSlider,
  relatedSlider,
  scrollSlider,
  informationListSlider,
} from './slider';
import { youkai } from './youkai';
import { changeMetaViewport } from './changeMetaViewport';
import { hashScroll } from './hashScroll';
import { inview } from './inview';
import { scrollTopButton } from './scrollTopButton';
import { selectBox } from './selectBox';
import { transitionClass } from './transitionClass';

import '../scss/style.scss';

articles();
categoryArticles();
featuresArticles();
focusArticles();
monthlyArticles();
monthlyDates();
searchArticles();
tagArticles();

hamburgerMenu();
scrollToCenterNav();

entryBoxSlider();
monthlySlider();
mvSlider();
relatedSlider();
scrollSlider();
informationListSlider();

youkai();
changeMetaViewport();
hashScroll();
inview();
scrollTopButton();
selectBox();
transitionClass();
